import styled from "styled-components";

export const customStyles = {
  container: (provided: any) => ({
    ...provided,
    fontFamily: "Inter",
    fontWeight: "400",
  }),
  control: (provided: any) => ({
    ...provided,
    border: "1px solid #ece6ee", // add color to theme?
    borderRadius: "5px",
  }),
  valueContainer: (provided: any) => ({
    ...provided,
    padding: "10px 15px",
  }),
  placeholder: (provided: any) => ({
    ...provided,
    color: "#b199ba",
  }),
  indicatorSeparator: (provided: any) => ({
    ...provided,
    display: "none",
  }),
};

export const Input = styled.input.attrs({
  className: "appearance-none rounded focus:outline-none ",
})`
  padding-left: 15px;
  width: 100%;
  color: inherit;
  background: 0px center;
  opacity: 1;
  grid-area: 1 / 2 / auto / auto;
  /* font: inherit; */
  min-width: 2px;
  border: 1px solid #69606c;
  margin: 0px;
  outline: 0px;
  &::placeholder {
    color: #b199ba;
  }
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  cursor: default;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  min-height: 54px;
  outline: 0 !important;
  position: relative;
  -webkit-transition: all 100ms;
  transition: all 100ms;
  background-color: hsl(0, 0%, 100%);
  border-color: hsl(0, 0%, 80%);
  border-radius: 5px;
  border-style: solid;
  border-width: 1px;
  box-sizing: border-box;
  border: 1px solid #ece6ee;
`;
export const NotListed = styled.span.attrs({
  className: "text-xs ml-1",
})`
  color: #d9d9d9;
`;
